import React from 'react';
import { MdCheckCircle } from 'react-icons/md';
import WebsiteNavbar from '../components/website/WebsiteNavbar';
import WebsiteFooter from '../components/website/WebsiteFooter';

const TermsPage: React.FC = () => {
  const sections = [
    {
      title: 'Eligibility & Account Registration',
      content: 'Welcome to CricClash. These terms govern your use of our fantasy cricket platform. To participate in CricClash, you must be at least 18 years of age or the minimum legal age for online gaming in your jurisdiction. You are responsible for ensuring that your registration data is accurate and up to date. Each user is permitted one account only.'
    },
    {
      title: 'Contest Participation',
      content: 'CricClash allows users to create and join private leagues with friends. You can build fantasy cricket teams, join contests, and compete on leaderboards. All contests on CricClash are completely free to enter. Users are expected to participate in good faith and maintain fair play at all times.'
    },
    {
      title: 'Fair Play & Anti-Fraud Policy',
      content: 'CricClash is committed to maintaining a fair and transparent platform. Multi-accounting, collusion, use of automated tools or bots, and any form of manipulation are strictly prohibited. Violations will result in immediate account suspension and forfeiture of contest standings. We employ advanced fraud detection systems to ensure platform integrity.'
    },
    {
      title: 'Limitation of Liability',
      content: 'CricClash provides its services on an "as is" basis. While we strive to ensure uninterrupted service, we are not liable for any losses arising from service interruptions, technical issues, or circumstances beyond our control. Users participate in contests at their own discretion, and past performance does not guarantee future results.'
    },
    {
      title: 'Service Termination',
      content: 'CricClash reserves the right to suspend or terminate user accounts that violate these terms. Users may also request account closure at any time. Upon termination, contest history will be archived. Certain provisions of these terms will survive account termination.'
    },
  ];

  const highlights = [
    { label: 'Confidentiality', description: 'Your data is encrypted and secure' },
    { label: 'Data Protection', description: 'GDPR and local compliance' },
    { label: '24/7 Support', description: 'Round-the-clock assistance' },
    { label: 'Live Scoring', description: 'Real-time match updates' },
  ];

  return (
    <div className="min-h-screen bg-[#0F1114]">
      <WebsiteNavbar />

      <div className="pt-24 pb-20 px-4">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="mb-12">
            <div className="inline-block px-3 py-1 bg-[#13EC5B]/10 border border-[#13EC5B]/20 rounded-full text-[#13EC5B] text-xs font-semibold mb-4 uppercase tracking-wider">
              Legal Information
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">Terms and Conditions</h1>
            <p className="text-gray-500">Last updated: October 15, 2025</p>
            <p className="text-gray-400 mt-4 leading-relaxed">
              Welcome to CricClash. These terms govern your use of our fantasy cricket platform. By accessing or using CricClash, you agree to be bound by these terms and conditions.
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-10">
            {sections.map((section, i) => (
              <div key={i}>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-[#13EC5B]/10 border border-[#13EC5B]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-[#13EC5B] font-bold text-sm">{i + 1}</span>
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white mb-3">{section.title}</h2>
                    <p className="text-gray-400 leading-relaxed">{section.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Key Highlights */}
          <div className="mt-16">
            <h2 className="text-2xl font-bold text-white mb-6">Key Highlights</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              {highlights.map((h, i) => (
                <div key={i} className="flex items-start gap-3 bg-[#111b18] border border-[#1a3a2a] rounded-xl p-4">
                  <MdCheckCircle className="w-5 h-5 text-[#13EC5B] flex-shrink-0 mt-0.5" />
                  <div>
                    <span className="text-white font-semibold text-sm block">{h.label}</span>
                    <span className="text-gray-500 text-sm">{h.description}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <WebsiteFooter />
    </div>
  );
};

export default TermsPage;
